import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactCSSTransitionReplace from 'react-css-transition-replace';

import * as SubscriptionActionCreators from 'actions/subscription';

import SubscriptionComponent from './Subscription';

interface Props {
  dispatch: Function,
  onClick?: () => void,
}

export class SubscriptionContainer extends Component<Props> {
  /**
   * Component Did Mount
   * @return {undefined}
   */
  componentDidMount = () => {
    const { dispatch } = this.props;
    dispatch(SubscriptionActionCreators.fetch());
  };

  render() {
    const { onClick } = this.props;
    return (
      <ReactCSSTransitionReplace transitionName="fade-wait" transitionEnterTimeout={100} transitionLeaveTimeout={100}>
        <SubscriptionComponent onClick={onClick} />
      </ReactCSSTransitionReplace>
    );
  }
}

export default connect()(SubscriptionContainer);